module.exports = new __parcel__URL__("squigglyShapes.583bd0fd.svg").toString();